import {
	type ComponentPropI,
	isResourceActionPublic,
	type PossibleActions,
	type ResourceName,
} from "@Common/types/resources";
import { usePublicMode } from "@Src/contexts/PublicModeContext";
import { useEffect } from "react";

// biome-ignore lint/suspicious/noExplicitAny: necessary here
export type WrappedComponent<T = any> = React.ComponentType<T> & {
	__isWrapped: boolean;
};

export const Wrapper = (
	resourceName: ResourceName,
	action: PossibleActions,
	WrappedComponentParam: (props: ComponentPropI) => JSX.Element,
): WrappedComponent => {
	const isPublic = isResourceActionPublic(resourceName, action);

	const WrappedComponent = () => {
		const { setIsPublic } = usePublicMode();
		useEffect(() => {
			setIsPublic(isPublic); // push wrapper info into context
			return () => setIsPublic(false); // reset when unmounting
		}, [setIsPublic]);
		return <WrappedComponentParam isPublic={isPublic} />;
	};
	return Object.assign(WrappedComponent, { __isWrapped: true });
};
